module.exports = __webpack_public_path__ + "img/message-text.0304061c.svg";